import { navigate } from "gatsby-link";
import React, { useState } from "react";
import styled from "styled-components";
import trackComponentAction from "../analytics/trackComponentAction";

const trackingProps = {
  componentName: "HelloBar",
  componentVersion: "0",
};

export const HELLO_BAR_CLOSED_DATASET_KEY = "helloBarClosed";

export const getHelloBarLocalStorageKey = (actionId: string) => `Upsolve.helloBarClosed.${actionId}`;

export const shouldShowHelloBar = (storageKey: string) => {
  if (typeof document !== "undefined" && document.documentElement.dataset[HELLO_BAR_CLOSED_DATASET_KEY] === "true") {
    return false;
  }
  if (typeof window === "undefined") return true;
  return !window.localStorage.getItem(storageKey);
};

export const setHelloBarClosed = (storageKey: string) => {
  localStorage.setItem(storageKey, "true");
  if (typeof document !== "undefined") {
    document.documentElement.dataset[HELLO_BAR_CLOSED_DATASET_KEY] = "true";
  }
};

const HelloBar = (props: {
  helloBarText: any;
  helloBarUrl: string;
  helloBarTrackingActionId: string;
}): React.ReactElement | null => {
  const helloBarLocalStorageKey = getHelloBarLocalStorageKey(props.helloBarTrackingActionId);
  const [showHelloBar, setShowHelloBar] = useState(shouldShowHelloBar(helloBarLocalStorageKey));
  if (!showHelloBar) return null;
  return (
    <HelloBarWrapper
      onClick={() => {
        trackComponentAction({
          ...trackingProps,
          actionId: props.helloBarTrackingActionId,
          actionMethod: "click",
        });
        navigate(props.helloBarUrl);
      }}
    >
      <HelloBarText>{props.helloBarText}</HelloBarText>
      <CloseButton
        onClick={(e) => {
          e.stopPropagation();
          setHelloBarClosed(helloBarLocalStorageKey);
          setShowHelloBar(false);
        }}
      >
        X
      </CloseButton>
    </HelloBarWrapper>
  );
};
const HelloBarText = styled.div`
  flex: 1;
`;
const CloseButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
`;
const HelloBarWrapper = styled.div`
  text-align: center;
  justify-content: space-between;
  display: flex;
  background: #ede8da;
  font-size: 18px;
  letter-spacing: 0.25px;
  padding: 10px;
  cursor: pointer;
  :hover {
    background: ${(props) => props.theme.colors.brand[800]};
  }
`;

export default HelloBar;
